package top.wcpe.allincore.dsl.compiler.semantic.`native`

import top.wcpe.allincore.dsl.compiler.source.SourcePosition

/**
 * 描述符 resolve 阶段的上下文。
 *
 * 此 ctx 后续 Stage 会追加字段（如 class registry / type info），
 * 第一版仅包含 call 节点位置与所属 screen id。
 */
data class ResolveCtx(
    /** call 节点位置，用于诊断 fallback。 */
    val position: SourcePosition,
    /** 来自 ScreenAst.id，标识当前所属 screen。 */
    val screenId: String,
)
